/* istanbul ignore file */
import React, { useState } from 'react';
import { useWindowScroll } from 'react-use';

import ArrowUpward from 'src/assets/svg/arrowUpward.svg';
import { IconButton } from 'src/components/atoms/IconButton';
import { useDebounce } from 'src/hooks/useDebounce';
import * as styles from '../styles';

interface Props {
  containerHeight: number;
}

export const JUMP_POINT_MARGIN = 2000;

export const BackToTopButton = ({ containerHeight }: Props) => {
  const [hasJumped, setHasJumped] = useState(false);
  const windowScroll = useWindowScroll();
  const jumpPointPosition =
    containerHeight < JUMP_POINT_MARGIN ? containerHeight / 2 : JUMP_POINT_MARGIN;

  const handleSmoothToTopScroll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setHasJumped(false);
  };

  const handleInitialJumpScroll = () => {
    window.scrollTo({ top: jumpPointPosition });
    setHasJumped(true);
  };

  useDebounce(handleSmoothToTopScroll, 100, [hasJumped]);

  const isVisible = windowScroll.y > jumpPointPosition;

  return (
    <IconButton
      css={styles.backToTopButton}
      icon={ArrowUpward}
      iconWidth={24}
      iconHeight={24}
      onClick={handleInitialJumpScroll}
      data-is-visible={isVisible}
    />
  );
};
